import React from 'react';
import styled from 'styled-components';

import TextLink from 'components/TextLink';
import { FullWidthPageContent } from 'layouts/SingleColumnLayout';
import addressesPath from 'containers/paths/AddressesContainerPath';

const Wrapper = styled(FullWidthPageContent)`

  color: ${({ theme }) => theme.palette.primary.contrastText};
  background-color: ${({ theme }) => theme.palette.background.primary};
  padding: ${({ theme }) => theme.spacing * 2}px;

  h1 {
    text-transform: capitalize;
  }
  hr{
    display: block;
    margin: ${({ theme }) => theme.spacing * 2}px 0;
    width: 44px;
    border: none;
    border-top: 1px solid ${({ theme }) => theme.palette.grey[3]};
  }
  .TextLink{
    color: inherit;
    margin-bottom: ${({ theme }) => theme.spacing * 2}px;
  }
`;

const Component = () => (
  <Wrapper>
    <h1>Addresses</h1>
    <p>Manage your address book</p>
    <hr />
    <TextLink
      rightChevron
      props={{ to: addressesPath({}, 'add', { search: '?allowDefaultAddress=true&allowAllFutureChange=true' }) }}
      dataLayer={{ action: 'Add New Address Click', label: 'Add New Address' }}
    >
      Add a new address
    </TextLink>
  </Wrapper>
);

export default Component;
